export default __webpack_public_path__ + "static/media/H.45c3896d.svg";